import { Link, NavLink } from "react-router-dom";
import { useSignedIn, type AdminModeState } from "@jkast90/kast-common/auth";

// The header is the game's, not an app's: brand and page links only. Signing
// in lives in the footer; the account link appears once signed in, and the
// admin link only with admin tools switched on.
export default function Header({ adminMode }: { adminMode: AdminModeState }) {
  const signedIn = useSignedIn();
  return (
    <header className="header">
      <Link to="/" className="brand">
        Salvagers
      </Link>
      <nav>
        <a href="/#captains">Captains</a>
        <a href="/#ships">Ships</a>
        <a href="/#art">Art</a>
        <NavLink to="/about">About</NavLink>
        {signedIn && <NavLink to="/account">Account</NavLink>}
        {adminMode.unlocked && <NavLink to="/admin">Admin</NavLink>}
      </nav>
      <a className="btn primary small" href={SHOP_URL} target="_blank" rel="noreferrer">
        Buy the game
      </a>
    </header>
  );
}

export const SHOP_URL = "https://www.thegamecrafter.com/games/permalink/CBD1D5DA-48CC-11F0-8057-C92CFC483417";
